import { createSlice, } from '@reduxjs/toolkit'
import { AppState } from '@app/store/state/app.state';

export interface UserAvatarInfoHoverState {
  isOpen: boolean;
  isLocked: boolean;
  cords: {x: number, y: number};
  firstName: string;
  lastName: string;
  jobTitle: string;
}

export const initialUserAvatarInfoHover: UserAvatarInfoHoverState = {
  isOpen: false,
  isLocked: false,
  cords: {x: 0, y: 0},
  firstName: '',
  lastName: '',
  jobTitle: '',
}

const userAvatarInfoHoverSlice = createSlice({
  name: 'userAvatarInfoHover',
  initialState: initialUserAvatarInfoHover,
  reducers: {
    setOpen: (state, action) => ({
      ...state,
      isOpen: action.payload.open,
      cords: action.payload.cords,
      firstName: action.payload.firstName,
      lastName: action.payload.lastName,
      jobTitle: action.payload.jobTitle,
    }),
    setLocked: (state, action) => ({
      ...state,
      isLocked: action.payload
    }),
  },
  extraReducers: (builder) => {}
})

export default userAvatarInfoHoverSlice.reducer;


// Selectors
const selectUserAvatarInfoVisibilityState = (state: AppState) => ({
  isOpen: state.userAvatarInfoHover.isOpen,
  cords: state.userAvatarInfoHover.cords,
  isLocked: state.userAvatarInfoHover.isLocked,
});

const selectUserAvatarInfo = (state: AppState) => ({
  firstName: state.userAvatarInfoHover.firstName,
  lastName: state.userAvatarInfoHover.lastName,
  jobTitle: state.userAvatarInfoHover.jobTitle,
})
